import { useGet } from '../../../../api';

interface Params {
    ruleName: string;
    diffInDays: number;
    sourceType: string;
    domainName: string[] | null;
}

interface TimelinePart {
    timestamp: number;
    count: number;
}

const useGetInsightTimeline = ({ ruleName, domainName = [], diffInDays, sourceType }: Params) => {
    const params: Record<string, unknown> = {
        diffInDays: diffInDays,
        sourceType
    };
    if (domainName) params.domainName = domainName;

    const { data, fetchData, error, loading } = useGet<TimelinePart[]>({
        url: `/insights/${ruleName}/timeline`,
        queryParams: params as Record<string, string>,
        enabled: !!ruleName
    });

    return { data, isFetching: loading, error, refresh: fetchData };
};

export default useGetInsightTimeline;
